import Text from '@deprecated-ui/common/Text';
import BaseButton from '@deprecated-ui/common/Button';
import BaseModal from '@deprecated-ui/common/Modal';
import styled from 'styled-components';

const Button = styled(BaseButton)`
  padding: 8px 15px;
`;

const Modal = styled(BaseModal)`
  .ant-modal-content {
    border-radius: 3px !important;
  }

  .ant-modal-header {
    border-top-left-radius: 3px !important;
    border-top-right-radius: 3px !important;
  }
`;

const ModalFooterContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 21px;
`;

const ModalContainer = styled.div`
  padding: 0 16px;
`;

const ModalTitle = styled(Text).attrs({
  size: '18px',
  family: 'bold',
  align: 'center',
  height: '40px',
})`
  padding: 10px 16px;
`;

export { ModalFooterContainer, ModalContainer, ModalTitle, Button, Modal };
